import React from 'react';
import 'moment/locale/de'; // Needed for date picker
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useTranslation } from 'react-i18next';
import theme from '../../theme';
import { findLang } from '../models/lang';

export const MuiProviders = ({ children }) => {
    const { i18n } = useTranslation();
    const locale = findLang(i18n.resolvedLanguage).datePickerLocale;

    const customTheme = responsiveFontSizes(createTheme(theme, locale));

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.resolvedLanguage}>
            <ThemeProvider theme={customTheme}>{children}</ThemeProvider>
        </LocalizationProvider>
    );
};
